import { Typography } from "@mui/material";
import { Palette as PaletteIcon } from "@mui/icons-material"
import FormBuilderDesign from "components/InputsDesign/FormBuilderDesign";
import { DataFields } from "./DataFields";

export default function GeneralAspectModule({ 
  t,
  dataInstance, 
  googleFonts, 
  register, 
  errors, 
  changeDataFunction, 
  setFieldImageManager, 
  openImageManager, 
  changeCompletePicker 
}) {

  return (<>
    <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}><PaletteIcon /> &nbsp; {t('designmenu_select_option_general_features')}</Typography>
    <FormBuilderDesign 
      dataDields={DataFields(t)}
      dataInstance={dataInstance}
      containerSelectOptions={{ googleFonts: googleFonts }}
      register={register}
      errors={errors}
      changeDataFunction={changeDataFunction}
      setFieldImageManager={setFieldImageManager}
      openImageManager={openImageManager}
      changeCompletePicker={changeCompletePicker}
    />
  </>)
}